"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var GradientScrollContainer = function GradientScrollContainer(_ref) {
  var children = _ref.children,
    itemCount = _ref.itemCount,
    scrollRef = _ref.scrollRef,
    stretchToFill = _ref.stretchToFill;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showLeftGradient = _useState2[0],
    setShowLeftGradient = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showRightGradient = _useState4[0],
    setShowRightGradient = _useState4[1];
  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      if (!scrollRef.current) {
        return;
      }
      var _scrollRef$current = scrollRef.current,
        scrollLeft = _scrollRef$current.scrollLeft,
        scrollWidth = _scrollRef$current.scrollWidth,
        clientWidth = _scrollRef$current.clientWidth;
      setShowLeftGradient(scrollLeft > 0);
      setShowRightGradient(scrollWidth > clientWidth && scrollLeft < scrollWidth - clientWidth);
    };
    var scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
      handleScroll(); // Initialize gradient visibility on mount
    }
    return function () {
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [itemCount, scrollRef]);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    showLeftGradient: showLeftGradient,
    showRightGradient: showRightGradient,
    stretchToFill: stretchToFill
  }, children);
};
var _default = exports["default"] = GradientScrollContainer; // -------------------------------- Styles -------------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "GradientScrollContainer__Container",
  componentId: "sc-owqzp7-0"
})(["position:relative;overflow-x:auto;white-space:nowrap;", " &::before,&::after{content:'';position:absolute;z-index:1;top:0;bottom:0;width:50px;pointer-events:none;transition:opacity 0.3s;}&::before{left:0;background:linear-gradient( to right,rgba(255,255,255,1),rgba(255,255,255,0) );opacity:", ";}&::after{right:0;background:linear-gradient( to left,rgba(255,255,255,1),rgba(255,255,255,0) );opacity:", ";}"], (0, _styledIs["default"])('stretchToFill')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        width: 100%;\n    "]))), function (props) {
  return props.showLeftGradient ? 1 : 0;
}, function (props) {
  return props.showRightGradient ? 1 : 0;
});
//# sourceMappingURL=GradientScrollContainer.js.map